import React, { useState, useCallback, useEffect } from "react";
import styled from "styled-components";
import Modal from "./modal";
import FormTitle from "components/formTitle";
import InputGroup from "components/inputGroup";
import Button, { StyledButton } from "components/button";
import logger from "utils/logger";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faFlag } from "@fortawesome/free-regular-svg-icons";
import { faShare, faFlag } from "@fortawesome/free-solid-svg-icons";
import { hoverTips } from "utils/mixin";
import Select from "components/select";
import data from "services/data";
import MiniPluginVer from "components/miniPluginVer";
import MiniPluginInfo from "components/miniPluginInfo";

const StyledPluginDepModal = styled.div`
  width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 25px;
`;

const StyledIcon = styled(FontAwesomeIcon)``;

const PluginDepModal = ({
  errorMessage,
  visible,
  type,
  data,
  pluginVerData,
  onClose,
  onAddDep,
}) => {
  const [form, setForm] = useState({
    depPlugVerId: "",
  });

  const [pluginAppId, setPluginAppId] = useState("");
  const [pluginName, setPluginName] = useState("");

  useEffect(() => {
    setForm({
      depPlugVerId: "",
    });
  }, [data, type]);

  useEffect(() => {
    if (visible) {
      setPluginAppId("");
      setForm({
        depPlugVerId: "",
      });
    }
  }, [visible]);

  const handleValueChange = useCallback(
    (name, value) => {
      const copy = { ...form };
      copy[name] = value;
      setForm(copy);
    },
    [form]
  );

  const handlePluginChange = useCallback((pluginData) => {
    setPluginAppId(pluginData?.appId);
    setPluginName(pluginData?.module);
  }, []);

  const handlePluginVerDepAdd = useCallback(() => {
    const copy = { ...form };
    logger.log("添加插件版本的表单信息： ", copy, pluginVerData);
    onAddDep && onAddDep(copy, pluginVerData);
  }, [pluginVerData, form, onAddDep]);

  const handleChooseDep = useCallback((data) => {
    setForm({
      depPlugVerId: data.id,
    });
  }, []);

  return (
    <Modal
      visible={visible}
      onClose={() => {
        onClose();
      }}
    >
      <StyledPluginDepModal
        onKeyUp={(e) => {
          e.preventDefault();
          //阻止事件进一步传播
          e.stopPropagation();
          switch (e.keyCode) {
            //回车 提交
            case 13:
              handlePluginVerDepAdd();
              break;
            //Esc 取消
            case 27:
              console.log("取消");
              onClose && onClose();
              break;
            default:
              return;
          }
        }}
      >
        <FormTitle>添加插件版本依赖</FormTitle>
        <InputGroup
          width="100%"
          inputWidth="200px"
          label="要依赖的版本id"
          type="text"
          name="depPlugVerId"
          value={form.depPlugVerId}
          onChange={handleValueChange}
          placeholder="depPlugVerId"
        />
        {pluginAppId ? (
          <MiniPluginVer
            pluginAppId={pluginAppId}
            pluginName={pluginName}
            onBack={() => setPluginAppId("")}
            onChooseDep={handleChooseDep}
          />
        ) : (
          <MiniPluginInfo onPluginChange={handlePluginChange} />
        )}

        <Button
          message={errorMessage}
          title="添加"
          onClick={handlePluginVerDepAdd}
        >
          Add
        </Button>
      </StyledPluginDepModal>
    </Modal>
  );
};

export default PluginDepModal;
